module.exports = __webpack_public_path__ + "206d8ef200520c698628d9301301c860.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-shift.png
// module id = 639
// module chunks = 0